import { Icon } from '@iconify/react';

type AccessLevelFilterBannerProps = {
  accessLevelCode: string;
  filterMessage: string;
};

const AccessLevelFilterBanner = ({
  accessLevelCode,
  filterMessage,
}: AccessLevelFilterBannerProps) => {
  const bannerText = filterMessage.replace(/\.$/, '');

  return (
    <div
      className="mt-2 flex w-fit flex-wrap items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-3 py-1.5 text-sm text-primary"
      // role="status"
      data-testid="access-level-filter-banner"
    >
      <Icon
        icon="mdi:shield-alert-outline"
        width={16}
        height={16}
        className="shrink-0 text-primary"
        aria-hidden
      />
      <span className="min-w-0 leading-5">{bannerText}</span>
      <span className="rounded-md bg-primary/20 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-primary">
        {accessLevelCode}
      </span>
    </div>
  );
};

export default AccessLevelFilterBanner;
